/**
 * Stable query key constants for report caches.
 * Exported separately so minister mutations can invalidate them
 * without importing the full report hooks (avoids circular deps).
 */

export const REPORT_QUERY_KEYS = {
  /** All ministers (active + inactive) with degree/district/region. Padrón General. */
  ministerRegistry: ["ministerRegistry"] as const,

  /** Active ministers for the uncredentialed tab in Lista de Ministros. */
  allActiveMinisters: ["allActiveMinisters"] as const,

  /** System-wide active minister counts grouped by degree. */
  ministerSystemDegreeCounts: ["ministerSystemDegreeCounts"] as const,

  /** Latest status_change notes per minister from minister_history. */
  ministerStatusNotes: ["ministerStatusNotes"] as const,
} as const;
